import { NotFoundPage } from "@components/NotFoundPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_data/$")({
  component: NotFoundPage,
});
